import { MONTHS_FR } from "@/lib/format";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export function PeriodSelector({ year, month, setYear, setMonth, showMonth = true }) {
  const years = [];
  const current = new Date().getFullYear();
  for (let y = current + 1; y >= current - 5; y--) years.push(y);

  return (
    <div className="flex items-center gap-2">
      {showMonth && (
        <Select value={String(month)} onValueChange={(v) => setMonth(Number(v))}>
          <SelectTrigger className="w-[140px] bg-card" data-testid="period-month-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {MONTHS_FR.map((m, i) => (
              <SelectItem key={i} value={String(i + 1)}>{m}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
        <SelectTrigger className="w-[100px] bg-card" data-testid="period-year-select">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {years.map((y) => (
            <SelectItem key={y} value={String(y)}>{y}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
